import React, { useContext, useState } from 'react';
import theme from '../theme/theme';
import { trunc } from '../utils';
import { globalStore } from '../state/store';
import { Avatar, Box, Grid, List, Menu, MenuItem, Pagination, Typography, useMediaQuery } from '@mui/material';
import { RankedListItem, SearchBar } from '../components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faEllipsisH, faPlusCircle } from '@fortawesome/free-solid-svg-icons';

const RankedList = ({isRankingScreen}) => {

    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

    const pagesize = 5

    const [state, dispatch] = useContext(globalStore);
    const [anchorElLeague, setAnchorElLeague] = useState(null);
    const [page, setPage] = useState(1);
    const [tryingToJoinLeague, setTryingToJoinLeague] = useState(false);
    const [rankedList, setRankedList] = React.useState(Boolean(state.user) && Boolean(state.leagues) && 
                                            Boolean(state.leagues.filter((l) => l === state.league)) && 
                                            state.leagues.filter((l) => l === state.league).length > 0 &&
                                            Boolean(state.leagues.filter((l) => l === state.league)[0]) ?
                                        state.leagues.filter((l) => l === state.league)[0].players
                                        .sort((a,b) => (a.pts > b.pts) ? -1 : ((b.pts > a.pts) ? 1 : 0)) : [])

    const handleOpenLeagueMenu = (event) => {
        setAnchorElLeague(event.currentTarget);
    };

    const handleCloseLeagueMenu = () => {
        setAnchorElLeague(null);
    };

    const changeActiveLeague = (newLeague) => {
        let newRankedList = Boolean(state.user) && Boolean(state.leagues) && 
              Boolean(state.leagues.filter((l) => l === state.league)) && 
              state.leagues.filter((l) => l === state.league).length > 0 &&
              Boolean(state.leagues.filter((l) => l === newLeague)[0].players) ?
          state.leagues.filter((l) => l === newLeague)[0].players
          .sort((a,b) => (a.pts > b.pts) ? -1 : ((b.pts > a.pts) ? 1 : 0)) : []
    
        //let nl = state.leagues.filter((l) => l.)
        dispatch({ type: "CHANGE_LEAGUEACTIVE", payload: newLeague })
        //todo change leagueactive
        setTryingToJoinLeague(false);
        setRankedList(newRankedList);
        setPage(Boolean(newRankedList) ? Math.ceil((newRankedList.findIndex((p) => p.uid === state.user.uid) + 1) / pagesize) : 1)
    }

    return (<>
              {
              state.leagues.filter((l) => l.lid === state.league.lid).length > 0 &&
              Boolean(state.leagues.filter((l) => l.lid === state.league.lid)[0]) &&
              !tryingToJoinLeague ?
              <>
                <Grid onClick={handleOpenLeagueMenu}
                container direction="row" justifyContent={"center"} 
                sx={{ border: isRankingScreen ?
                    '1px solid' + theme.palette.grey[300] :
                    '0px solid' + theme.palette.grey[400], borderRadius: '30px',
                  backgroundColor: isRankingScreen ? 
                    theme.palette.grey[100] : 
                    theme.palette.primary.contrastText, 
                  margin: '25px 0px 10px 0px',
                  cursor: 'pointer',
                  '&:hover': { border: isRankingScreen ?
                    '1px solid' + theme.palette.grey[300] :
                    '0px solid' + theme.palette.grey[400],
                    backgroundColor: theme.palette.grey[200]}
                }}>
                  <Grid item>
                  <Grid container direction="row" alignItems={"center"} sx={{mt: isSmUp ? 2 : 1.2, mb: isSmUp ? 2 : 1.2}}>
                    <Grid item>
                      <Avatar src={state.leagues.filter((l) => l.lid === state.league.lid)[0].logoURL} 
                      style={{width: isSmUp ? '70px': '50px', height: isSmUp ? '70px': '50px', 
                        backgroundColor: theme.palette.primary.contrastText,
                      }} />
                    </Grid>
                    <Grid item sx={{margin: isSmUp ? '10px 20px 10px 20px' : '10px 15px 10px 15px'}}>
                      <Typography><span style={{fontWeight: '900', display: isSmUp ? 'inline-block' : 'none'}}>League:</span> {trunc(state.leagues.filter((l) => l.lid === state.league.lid)[0].name, isSmUp ? 20 : 16)}</Typography>
                      <Typography><span style={{fontWeight: '900', display: isSmUp ? 'inline-block' : 'none'}}>Creator:</span> {trunc(state.leagues.filter((l) => l.lid === state.league.lid)[0].createdBy, isSmUp ? 20 : 16)}</Typography>
                    </Grid>
                    <Grid item sx={{ml: 2}}>
                      <FontAwesomeIcon icon={faCaretDown} />
                    </Grid>
                  </Grid>
                  </Grid>
                </Grid>
                <Menu
                  sx={{ mt: '75px' }}
                  id="menu-appbar"
                  anchorEl={anchorElLeague}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={Boolean(anchorElLeague)}
                  onClose={handleCloseLeagueMenu}
                >
                  {state.leagues.map((l, i) => (
                      <MenuItem sx={{width: '250px'}}
                      key={i} value={i} onClick={e => { changeActiveLeague(l); handleCloseLeagueMenu()}}
                      selected={l === state.league}>
                        <Avatar src={l.logoURL} style={{width: '25px', height: '25px', marginRight: '15px'}} /> <Typography sx={{fontWeight: '400'}}>{l.name}</Typography>                      
                      </MenuItem>
                    ))}
                      <MenuItem sx={{width: '250px'}} onClick={() => { setTryingToJoinLeague(true); handleCloseLeagueMenu()}}>
                        <FontAwesomeIcon icon={faPlusCircle} style={{margin: '5px 21px 5px 5px', color: theme.palette.primary.main}} /> <Typography sx={{fontWeight: '700', fontSize: '12px', color: theme.palette.grey[700], fontStyle: 'normal'}}>Join another league</Typography>
                      </MenuItem>
                </Menu>

                {Boolean(rankedList) ?
                <>
                  <List sx={{ width: '100%' }}>

                    {page > 1 ? // show number 1
                    <React.Fragment>
                      <RankedListItem isRankingScreen={isRankingScreen}
                      page={page} pagesize={pagesize} p={rankedList[0]} i={"first"} user={state.user} leagues={state.leagues} league={state.league} />
                      <Box align={"center"}><FontAwesomeIcon icon={faEllipsisH} style={{color: theme.palette.grey[700], margin: '4px 0px 4px 0px'}} /></Box>
                    </React.Fragment>
                    :''}

                    {rankedList // show specific page of ranked players
                    .slice((page - 1) * pagesize, page * pagesize)
                    .map((p, i) => (

                      <RankedListItem isRankingScreen={isRankingScreen} key={i} page={page} pagesize={pagesize} p={p} i={i} user={state.user} leagues={state.leagues} league={state.league} />

                    ))}

                    {page < Math.ceil(rankedList.length / pagesize) ? // show number last
                    <React.Fragment>
                      <Box align={"center"}><FontAwesomeIcon icon={faEllipsisH} style={{color: theme.palette.grey[700], margin: '4px 0px 4px 0px'}} /></Box>
                      <RankedListItem isRankingScreen={isRankingScreen} page={page} pagesize={pagesize} p={rankedList[rankedList.length - 1]} i={"last"} user={state.user} leagues={state.leagues} league={state.league} totalPlayers={rankedList.length} />
                    </React.Fragment>
                    :''}
                  </List>
                  <Grid direction="row" container justifyContent={"center"} sx={{mt:2}}>
                    <Grid item>
                      {Boolean(state.leagues) && 
                      state.leagues.filter((l) => l.lid === state.league.lid).length > 0 &&
                      Boolean(state.leagues.filter((l) => l.lid === state.league.lid)) ?
                        <Pagination 
                        count={Math.ceil(state.leagues.filter((l) => l.lid === state.league.lid)[0].players.length / pagesize)} color="primary"
                        page={page}
                        onChange={(e,val) => setPage(val)} />
                      :''}
                    </Grid>
                  </Grid>
                </>
                :''}
              </>
              :
              <>
              <Box sx={{mt:5, mb: isRankingScreen ? 5 : 4}}>

                <Typography align="center" sx={{mb:5}}>
                  {tryingToJoinLeague ?
                    "Join another league."
                    :
                    "You have not yet joined a league."
                    }
                </Typography>

                <Box sx={{px:2}}>
                  <SearchBar />
                </Box>
                
                

              </Box>
              </>
              }
            </>
    )
};
export default RankedList;